type SoundClipNodeDataRecord = Record<string, unknown>

/**
 * Replace legacy and React Flow sound clip fields with one current selection.
 * Callers must replace the node data so stale raw legacy fields are removed.
 */
export function withSoundClipSelection<T extends SoundClipNodeDataRecord>(
  data: T,
  soundClipId: string | undefined,
  soundClipUuid: string | undefined,
): T {
  const nextData: SoundClipNodeDataRecord = { ...data }

  delete nextData.sound_clip_id
  delete nextData.sound_clip_uuid
  delete nextData.soundClipId
  delete nextData.soundClipUuid

  if (soundClipId) {
    nextData.soundClipId = soundClipId
  }
  if (soundClipId && soundClipUuid) {
    nextData.soundClipUuid = soundClipUuid
  }

  return nextData as T
}
